const Assets = {
  facebook: "src/assets/facebook.svg",
  featuredProductNovaTowerWoodStove:
    "/assets/featured-product-nova-tower-wood-stove.jpg",
  instagram: "src/assets/instagram.svg",
  linkedin: "src/assets/linkedin.svg",
  logo: "/assets/logo.svg",
  logoBlack: "/assets/logo-black.svg",
  logoWhite: "/assets/logo-white.svg",
  twitter: "src/assets/twitter.svg",
  fileIcon: "/assets/file-icon.png",
  fileSuccessIcon: "/assets/file-success-icon.png",
  fileFailedIcon: "/assets/file-failed.png",
  demoVideo: "/assets/demo_video_720.mp4",
  demoVideoPreview: "/assets/demo_video_preview.png",
};

export default Assets;